<template>
    <div class="RequestListPage CatalogPage">
        <div class="container">
            <div class="filters" v-if="$mqAbove('MOBILE')">
              <TaskFilter @change="filterChange" :params="filter">
                <template #footer>
                  <svg class="pointer m-1" width="21" height="14" viewBox="0 0 21 14"
                       :fill="layout==='line'?'#6367A7':'#D9D9D9'"
                       xmlns="http://www.w3.org/2000/svg" @click="setLayout('line')">
                      <rect width="21" height="2" rx="1" fill=""/>
                      <rect y="6" width="21" height="2" rx="1" fill=""/>
                      <rect y="12" width="21" height="2" rx="1" fill=""/>
                  </svg>

                  <svg class="pointer m-1" width="16" height="16" viewBox="0 0 16 16"
                       :fill="layout==='grid'?'#6367A7':'#D9D9D9'"
                       xmlns="http://www.w3.org/2000/svg" @click="setLayout('grid')">
                      <rect width="6" height="6" rx="2" fill=""/>
                      <rect y="10" width="6" height="6" rx="2" fill=""/>
                      <rect x="10" width="6" height="6" rx="2" fill=""/>
                      <rect x="10" y="10" width="6" height="6" rx="2" fill=""/>
                  </svg>




                </template>
              </TaskFilter>
            </div>
            <div class="filters--mobile" v-else>
                <div class="filters&#45;&#45;mobileHeading">
                    <span>{{params.filter.messages.title}}</span>
                    <img src="/local/templates/main/img/icons/filters.svg" alt="" @click="toggleMobileFilters(true)">
                </div>
                <div class="filtersMobileMenu" :class="{'filtersMobileMenu&#45;&#45;opened': filtersOpened}">
                    <div class="header__actions-mob flex v-center menu-toggle">
                        <ABtn @click="toggleMobileFilters(false)" :class="{active: true}">
                            <template #content>
                                <div class="icon">
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                    <svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 0H0V2H20V0Z"></path>
                                    </svg>
                                </div>
                            </template>
                        </ABtn>
                    </div>
                    <TaskFilter @change="filterChange" :params="filter"/>
                </div>
            </div>
            <div class="row">
                <div class="col d12">
                    <div class="list" :class="'list--'+layout">
                        <TaskCard v-for="item in items"
                                  :volunteers="item.volunteers"
                                  :responds="item.responds"
                                  :rating_min="item.rating_min"
                                  :rating_max="item.rating_max"
                                  :title="item.title"
                                  :text="item.text"
                                  :image="item.img"
                                  :url="item.url"
                                  :deadline="item.deadline"
                                  :category="item.category"
                                  :layout="layout"
                        />
                    </div>
                    <ABtn v-if="pagen?.res?.nextPage" :label="pagen?.btnMess" @click.prevent="showMore" class="transparent gray w-100"/>
                </div>
            </div>
            <section class="reply" v-html="params.include_files?.application"></section>
            <section class="info" >
              <div class="row">
                <div class="col d12" v-if="params?.information">
                  <InfoCard :img="params.information?.img">
                    <h2>{{params.information?.title}}</h2>
                    <ul v-if="params.information?.list">
                      <li v-for="item in params.information?.list">
                        <strong>{{item.title}}</strong><br>
                        {{item.text}}
                      </li>
                    </ul>
                  </InfoCard>
                </div>
              </div>
            </section>
        </div>
    </div>
</template>

<script>
import {onUpdated, ref} from 'vue'
import useFilterControls from "~/composables/useFilterControls";
import {ABtn, ABadge, ASelect, ADatePicker} from '~/components/ui'
import TaskCard from "~/components/cards/TaskCard";
import InfoCard from "~/components/cards/InfoCard";
import {useAProgressBar} from "~/components/ui";
import {send} from "../../services/api";
import TaskFilter from "../../components/forms/TaskFilter.vue";

export default {
    name: "RequestListPageContainer",
    props: ['params'],
    components: {
        InfoCard,
        ABtn, ABadge, ASelect, ADatePicker, TaskCard,TaskFilter
    },
    setup(props) {
        const fieldData = ref({})
        const items = ref(props.params.items);
        const filter = ref(props.params.filter);
        const pagen = ref(props.params.pagination);
        const layout = ref('grid')
        const {filtersOpened, toggleMobileFilters} = useFilterControls();
        const progress = useAProgressBar();
        const showMore = async () => {
          progress.show();
          await send(pagen.value.res.nextPage, {method: "GET"}, {}).then((response) => {
            pagen.value = response[props.params.responseKey].pagination;
            for (let index in response[props.params.responseKey].items) {
              if(typeof response[props.params.responseKey].items[index]=== 'object') {
                items.value.push(response[props.params.responseKey].items[index]);
              }
            }
            progress.hide();
          });
        }
        const setLayout = (type) => {
            switch (type) {
                case 'line':
                    layout.value = 'line'
                    break;

                case 'grid':
                    layout.value = 'grid'
                    break;

                default:
                    return 'grid'
            }
        }

        const filterChange = async (e) => {


          progress.show();
          await send(e.url, {method: "GET"}, {api:'y'}).then((response) => {
            items.value = response[props.params.responseKey].items;
            filter.value = response[props.params.responseKey].filter;
            console.log(filter);
            pagen.value = response[props.params.responseKey].pagination;
            window.history.replaceState(response[props.params.responseKey], "", e.url);
            progress.hide();
          });

        }



        return {
            fieldData,
            setLayout,
          filterChange,
          filter,
            items,
            pagen,
            layout,
            showMore,
            filtersOpened,
            toggleMobileFilters
        }
    },

}
</script>

<style scoped lang="scss">
.RequestListPage {

    .reply {
        padding: rem(100) 0;

        @include mobile {
            padding: rem(50) 0;
        }
    }

    .contacts {
        padding-top: rem(10);
    }
}
</style>